import { Action } from '@ngrx/store';
import { ReportState, INITIALSTATE } from './state';
import { Actions, ActionTypes } from './actions';

export function ReportReducer(state = INITIALSTATE, action: Actions): ReportState {
  switch (action.type) {
    case ActionTypes.GET_REPORT_REQUEST:
      return {
        ...state,
        loader: action.loader,
      };
    case ActionTypes.GET_REPORT_SUCCESS:
      return {
        ...state,
        balanceSheet: action.payload,
        loader: false,
      };
    default: {
      return state;
    }
  }
}
